import { render, staticRenderFns } from "./DocumentosPendientesDeFirmar.vue?vue&type=template&id=12efaf7a&"
import script from "./DocumentosPendientesDeFirmar.vue?vue&type=script&lang=js&"
export * from "./DocumentosPendientesDeFirmar.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosPendientesDeFirmar.vue?vue&type=style&index=0&id=12efaf7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports